import {Component, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {QuestionOptions} from '../../../constants/question-options';
import {CustomValidators} from '../../../validator/custom-validator';
import {CompanyFormBase} from '../company-form-base/company-form-base.component';
import {Company} from '../../../model/proposal/company';
import {AuthService} from '../../../services/auth/auth.service';


@Component({
    selector: 'app-address-information-company-form',
    templateUrl: './address-information-company-form.component.html',
    styleUrls: ['../../../../styles/form-input.scss'],
    providers: [{ provide: CompanyFormBase, useExisting: AddressInformationCompanyFormComponent }],
    standalone: false
})
export class AddressInformationCompanyFormComponent extends CompanyFormBase implements OnInit{
  QuestionOptions = QuestionOptions;

  constructor(private readonly fb: FormBuilder,
              public authService: AuthService) {
    super();
  }

  formGroup = this.fb.group({
    companyName: [{value: '', disabled: true}, [Validators.required]],
    street: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    houseNumber: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    postalCode: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    location: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    countryCode: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
  });

  ngOnInit() {
    this.formGroup.patchValue({companyName: this.authService.getCompanyNameFromAccessToken()});
  }


  updateCompany(company: Company): void {
    company.street = this.formGroup.value.street;
    company.houseNumber = this.formGroup.value.houseNumber;
    company.postalCode = this.formGroup.value.postalCode;
    company.location = this.formGroup.value.location;
    company.countryCode = this.formGroup.value.countryCode;
  }
}
